import { Box, Button, Dialog, DialogContent, FormControl } from "@mui/material";
import { MobileDatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import DateLocalizationProvider from "../../../../components/element/DateLocalizationProvider";
import { DATE_FORMAT } from "../../../../utils/constants";
import "../InvoiceScreen.css";

function Filters({
  onApplyFilters,
  onClearFilters,
  showBankDetails = false,
  filters: parentFilters,
  bankConfig = {},
}) {
  // Layout and responsiveness handled via CSS in InvoiceScreen.css

  const [filters, setFilters] = useState({
    invoiceNumber: "",
    invoiceDate: "",
    invoiceDueDate: "",
  });


  const [selectedFromDate, setSelectedFromDate] = useState();
  const [openBankDetailsDialog, setOpenBankDetailsDialog] = useState(false);
  const [selectedDueDate, setSelectedDueDate] = useState();

  useEffect(() => {
    if (parentFilters) {
      setFilters(parentFilters);
      if (parentFilters.invoiceDate) {
        setSelectedFromDate(dayjs(parentFilters.invoiceDate));
      }
      if (parentFilters.invoiceDueDate) {
        setSelectedDueDate(dayjs(parentFilters.invoiceDueDate));
      }
    }
  }, [parentFilters]);

  const handleFromDateChange = (newValue) => {
    setSelectedFromDate(newValue);
  };

  const handleDueDateChange = (newValue) => {
    setSelectedDueDate(newValue);
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value,
    }));
  };

  const handleClearFilters = () => {
    setFilters({
      invoiceNumber: "",
      invoiceDueDate: "",
      invoiceDate: "",
    });
    setSelectedFromDate(null);
    setSelectedDueDate(null);
    if (onClearFilters) onClearFilters();
  };

  const handleOpenBankDetails = () => {
    setOpenBankDetailsDialog(true);
  };

  return (
    <Box className="filters-container">
      <FormControl
        variant="outlined"
        size="small"
        className="filter-item"

      >
        <div className="filter-header">Invoice Number</div>
        <input
          className="flight-input"
          id="invoiceNumber"
          name="invoiceNumber"
          type="text"
          placeholder="Enter Invoice Number"
          value={filters.invoiceNumber}
          onChange={handleFilterChange}
          autoComplete="off"
          maxLength={15}

        />
      </FormControl>

      <DateLocalizationProvider>
        <FormControl variant="outlined" className="filter-item" size="small">
          <div className="filter-header">Invoice Date</div>
          <MobileDatePicker
            id="filter-from-date-picker"
            className="filter-datepicker"
            format={DATE_FORMAT}
            value={selectedFromDate}
            onChange={handleFromDateChange}

          />
        </FormControl>
      </DateLocalizationProvider>
      <DateLocalizationProvider>
        <FormControl variant="outlined" className="filter-item" size="small">
          <div className="filter-header">Invoice Due Date</div>
          <MobileDatePicker
            id="filter-due-date-picker"
            className="filter-datepicker"
            format={DATE_FORMAT}
            value={selectedDueDate}
            onChange={handleDueDateChange}

          />
        </FormControl>
      </DateLocalizationProvider>

      {/* Spacer to push buttons to far right on large screens */}
      <Box className="filters-spacer" />

      <Box
        className="filter-buttons"

      >
        {showBankDetails && (
          <Button
            variant="contained"
            color="secondary"
            onClick={handleOpenBankDetails}

          >
            Bank Details
          </Button>
        )}
        <Button
          variant="text"
          color="primary"
          onClick={handleClearFilters}
          className="filter-button"

        >
          Clear
        </Button>
        <Button
          variant="contained"
          color="secondaryButton"
          onClick={() => {
            if (onApplyFilters)
              onApplyFilters(filters, selectedFromDate, selectedDueDate);
          }}

        >
          Apply
        </Button>
      </Box>

      <Dialog
        open={openBankDetailsDialog ?? false}
        onClose={() => setOpenBankDetailsDialog(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogContent>
          <div className="bank-details-container">
            <div className="bank-details-section">
              <h2>BSD Banking Details</h2>
              <div className="bank-details-content">
                <div className="bank-detail-row">
                  <span className="bank-detail-label">Account Name:</span>
                  <span className="bank-detail-value">
                    {bankConfig?.data?.bsdAccountName}
                  </span>
                </div>
                <div className="bank-detail-row">
                  <span className="bank-detail-label">Bank Name:</span>
                  <span className="bank-detail-value">
                    {bankConfig?.data?.bsdBankName}
                  </span>
                </div>
                <div className="bank-detail-row">
                  <span className="bank-detail-label">Branch Number:</span>
                  <span className="bank-detail-value">
                    {bankConfig?.data?.bsdBranchNumber}
                  </span>
                </div>
                <div className="bank-detail-row">
                  <span className="bank-detail-label">Account Number:</span>
                  <span className="bank-detail-value">
                    {bankConfig?.data?.bsdAccountNumber}
                  </span>
                </div>
              </div>
            </div>

            <div className="bank-details-section">
              <h3>USD Banking Details</h3>
              <div className="bank-details-content">
                <div className="bank-detail-row">
                  <span className="bank-detail-label">Intermediary Bank:</span>
                  <span className="bank-detail-value">
                    {bankConfig?.data?.usdIntermediaryBank}
                  </span>
                </div>
                <div className="bank-detail-row">
                  <span className="bank-detail-label">ABA:</span>
                  <span className="bank-detail-value">
                    {bankConfig?.data?.usdAba}
                  </span>
                </div>
                <div className="bank-detail-row">
                  <span className="bank-detail-label">SWIFT:</span>
                  <span className="bank-detail-value">
                    {bankConfig?.data?.usdSwift}
                  </span>
                </div>
                <div className="bank-detail-row">
                  <span className="bank-detail-label">
                    For Credit to Account:
                  </span>
                  <span className="bank-detail-value">
                    {bankConfig?.data?.usdCreditAccount}
                  </span>
                </div>
                <div className="bank-detail-row">
                  <span className="bank-detail-label">Beneficiary Bank:</span>
                  <span className="bank-detail-value">
                    {bankConfig?.data?.usdBeneficiaryBank}
                  </span>
                </div>
                <div className="bank-detail-row">
                  <span className="bank-detail-label">
                    Bahamas Transit Number:
                  </span>
                  <span className="bank-detail-value">
                    {bankConfig?.data?.usdBahamasTransitNumber}
                  </span>
                </div>
                <div className="bank-detail-row">
                  <span className="bank-detail-label">Account Number:</span>
                  <span className="bank-detail-value">
                    {bankConfig?.data?.usdAccountNumber}
                  </span>
                </div>
                <div className="bank-detail-row">
                  <span className="bank-detail-label">Beneficiary Name:</span>
                  <span className="bank-detail-value">
                    {bankConfig?.data?.usdBeneficiaryName}
                  </span>
                </div>
              </div>
            </div>
            <Button
              variant="contained"
              color="secondaryButton"
              className="done-button"
              onClick={() => setOpenBankDetailsDialog(false)}
            >
              Done
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </Box>
  );
}

export default Filters;
